import { FilterProps } from '~/pages/main/Ratings/components/Filter';
import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SET_ROWS_ORIENTATION,
  SET_ORDER,
  SET_ORDERBY,
  GET_FILTER_REQUEST,
  GET_FILTER_SUCCESS,
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  SEARCH,
  SHARE_CSV,
  GET_ALL_SELECTS_REQUEST,
  GET_ALL_SELECTS_SUCCESS,
  SET_LOADING_SELECTS
} from './ratings-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const getFilterRequest = (queryString = '') => {
  return {
    type: GET_FILTER_REQUEST,
    queryString
  };
};

export const getFilterSuccess = (products: any, rowsCount?: any) => {
  return {
    type: GET_FILTER_SUCCESS,
    products,
    rowsCount
  };
};

export const getAllRequest = (filters?: FilterProps) => {
  return {
    type: GET_ALL_REQUEST,
    filters
  };
};

export const getAllSuccess = (payload: any) => {
  return {
    type: GET_ALL_SUCCESS,
    payload
  };
};

export const getAllSelectsRequest = (client?: string) => {
  return {
    type: GET_ALL_SELECTS_REQUEST,
    client
  };
};

export const getAllSelectsSuccess = (payload: any) => {
  return {
    type: GET_ALL_SELECTS_SUCCESS,
    payload
  };
};

export const setLoadingSelects = (loading: Boolean) => {
  return {
    type: SET_LOADING_SELECTS,
    loading
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setRowsOrientation = (rowsOrientation: string) => {
  return {
    type: SET_ROWS_ORIENTATION,
    rowsOrientation
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const search = (queryString: string) => {
  return {
    type: SEARCH,
    queryString
  };
};

export const shareCsv = (filters?: FilterProps) => {
  return {
    type: SHARE_CSV,
    filters
  };
};
